import React, { useState, useRef, useEffect } from "react";
import CSVReader from "react-csv-reader";
import Page from "../2/Controls/Page";
import firebase, { database, auth } from "../../firebase";
import Loader from "../Loader";
import axios from "axios";

function PincodeSmartMerchantDashboard() {
  const [data, setData] = useState([]);
  const [results, setResults] = useState({ success: [], errors: [] });
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [csvKey, setCsvKey] = useState(Date.now());

  // ✅ all required fields
  const requiredFields = [
    "margin_date",
    "week_to_date",
    "month_to_date",
    "online_gmv_daily",
    "online_gmv_wtd",
    "online_gmv_mtd",
    "offline_gmv_daily",
    "offline_gmv_wtd",
    "offline_gmv_mtd",
    "daily_total_gmv",
    "wtd_total_gmv",
    "mtd_total_gmv",
    "daily_online_sale_smart_item_cohort_1",
    "wtd_online_sale_smart_item_cohort_1",
    "mtd_online_sale_smart_item_cohort_1",
    "daily_online_sale_smart_item_cohort_2",
    "wtd_online_sale_smart_item_cohort_2",
    "mtd_online_sale_smart_item_cohort_2",
    "daily_total_online_smart_item_sale",
    "wtd_total_online_smart_item_sale",
    "mtd_total_online_smart_item_sale",
    "daily_offline_sale_smart_item_sale",
    "wtd_offline_sale_smart_item_sale",
    "mtd_offline_sale_smart_item_sale",
    "daily_total_smart_item_sale",
    "wtd_total_smart_item_sale",
    "mtd_total_smart_item_sale",
    "total_online_cost_price_cohort_1_excl_gst",
    "wtd_total_online_cost_price_cohort_1_excl_gst",
    "mtd_total_online_cost_price_cohort_1_excl_gst",
    "total_online_earning_cohort_1",
    "wtd_total_online_earning_cohort_1",
    "mtd_total_online_earning_cohort_1",
    "total_online_cost_price_cohort_2_excl_gst",
    "wtd_total_online_earning_cohort_2",
    "wtd_total_online_earning",
    "wtd_total_online_cost_price_cohort_2_excl_gst",
    "mtd_total_online_cost_price_cohort_2_excl_gst",
    "total_online_earning_cohort_2",
    "mtd_total_online_earning_cohort_2",
    "total_online_earning",
    "mtd_total_online_earning",
    "total_offline_cost_price_excl_gst",
    "wtd_total_offline_cost_price_excl_gst",
    "mtd_total_offline_cost_price_excl_gst",
    "total_offline_earning",
    "wtd_total_offline_earning",
    "mtd_total_offline_earning",
    "total_earning",
    "wtd_total_earning",
    "mtd_total_earning",
    "online_gmv_non_smart_daily",
    "online_gmv_non_smart_wtd",
    "online_gmv_non_smart_mtd",
    "non_smart_online_commission_incl_gst_daily",
    "non_smart_online_commission_incl_gst_wtd",
    "non_smart_online_commission_incl_gst_mtd",
    "daily_grn_value_smart_item_incl_gst",
    "wtd_grn_value_smart_item_incl_gst",
    "mtd_grn_value_smart_item_incl_gst",
    "value_of_inventory_available_in_store",
    "fund_held",
    "total_value_held_for_smart_items",
    "value_of_required_inventory",
    "value_to_be_accumulated_for_ideal_assortment",
    "last_margin_settled_amount",
    "excess_funds_settlement_amount",
    "total_settlement_amount",
    "num_of_sku_of_required_inventory",
    "last_margin_settled_date",
    "excess_funds_settlement_date",
    "total_settlement_made_on",
    // "target_investment", //TargetInvestment
    // "total_sku_will_be_supplied", //TotalSKUToBeSupplied
    // "inventory_of_smart_sku", //InventoryOfSmartSKU
    // "fund_held", //FundHeld
    // "shortfall_amount_to_be_credited_to_pincode", //ShortFallAmountToBeCreditedToPincode
    // "value_of_required_inventory",
    // "num_of_sku_of_required_inventory",
    // "value_of_inventory_available_in_store",
    // "value_to_be_accumulated_for_ideal_assortment",
    "expiry_date",
    "expiry_raised_fnv",
    "wtd_expiry_raised_fnv",
    "mtd_expiry_raised_fnv",
    "ltd_expiry_raised_fnv",
    "expiry_raised_dbe",
    "wtd_expiry_raised_dbe",
    "mtd_expiry_raised_dbe",
    "ltd_expiry_raised_dbe",
    "expiry_raised_others",
    "wtd_expiry_raised_others",
    "mtd_expiry_raised_others",
    "ltd_expiry_raised_others",
    "expiry_raised_total",
    "wtd_expiry_raised_total",
    "mtd_expiry_raised_total",
    "ltd_expiry_raised_total",
    "expiry_approved_fnv",
    "wtd_expiry_approved_fnv",
    "mtd_expiry_approved_fnv",
    "ltd_expiry_approved_fnv",
    "expiry_approved_dbe",
    "wtd_expiry_approved_dbe",
    "mtd_expiry_approved_dbe",
    "ltd_expiry_approved_dbe",
    "expiry_approved_others",
    "wtd_expiry_approved_others",
    "mtd_expiry_approved_others",
    "ltd_expiry_approved_others",
    "expiry_approved_total",
    "wtd_expiry_approved_total",
    "mtd_expiry_approved_total",
    "ltd_expiry_approved_total",
    "store_id",
  ];

  //   const requiredFields = [
  //   margin_date",
  // week_to_date",
  // month_to_date",
  // online_gmv_daily",
  // online_gmv_wtd",
  // Online_gmv_mtd",
  // offline_gmv_daily",
  // offline_gmv_wtd",
  // offline_gmv_mtd",
  // daily_total_gmv",
  // wtd_total_gmv",
  // mtd_total_gmv",
  // daily_online_sale_smart_item_cohort_1",
  // wtd_online_sale_smart_item_cohort_1",
  // mtd_online_sale_smart_item_cohort_1",
  // daily_online_sale_smart_item_cohort_2",
  // wtd_online_sale_smart_item_cohort_2",
  // mtd_online_sale_smart_item_cohort_2",
  // daily_total_online_smart_item_sale",
  // wtd_total_online_smart_item_sale",
  // mtd_total_online_smart_item_sale",
  // daily_offline_sale_smart_item_sale",
  // wtd_offline_sale_smart_item_sale",
  // mtd_offline_sale_smart_item_sale",
  // daily_total_smart_item_sale",
  // wtd_total_smart_item_sale",
  // mtd_total_smart_item_sale",
  // total_online_cost_price_cohort_1_excl_gst",
  // wtd_total_online_cost_price_cohort_1_excl_gst",
  // mtd_total_online_cost_price_cohort_1_excl_gst",
  // total_online_earning_cohort_1",
  // total_online_earning_cohort_1",
  // mtd_total_online_earning_cohort_1",
  // total_online_cost_price_cohort_2_excl_gst",
  // wtd_total_online_cost_price_cohort_2_excl_gst",
  // mtd_total_online_cost_price_cohort_2_excl_gst",
  // total_online_earning_cohort_2",
  // total_online_earning_cohort_2",
  // mtd_total_online_earning_cohort_2",
  // total_online_earning",
  // total_online_earning",
  // mtd_total_online_earning",
  // total_offline_cost_price_excl_gst",
  // wtd_total_offline_cost_price_excl_gst",
  // mtd_total_offline_cost_price_excl_gst",
  // total_offline_earning",
  // wtd_total_offline_earning",
  // mtd_total_offline_earning",
  // total_earning",
  // wtd_total_earning",
  // mtd_total_earning",
  // online_gmv_non_smart_daily",
  // online_gmv_non_smart_wtd",
  // "online_gmv_non_smart_mtd",
  // non_smart_online_comminsion_incl_gst_daily",
  // non_smart_online_commission_incl_gst_wtd",
  // non_smart_online_commission_incl_gst_mtd",
  // daily_grn_value_smart_item_incl_gst",
  // wtd_grn_value_smart_item_incl_gst",
  // mtd_grn_value_smart_item_incl_gst",
  // value_of_inventory_available_in_store",
  // fund_held",
  // total_value_held_for_smart_items",
  // value_of_required_inventory",
  // value_to_be_accumulated_for_ideal_assortment",
  // last_margin_settled_amount",
  // excess_funds_settlement_amount",
  // total_settlement_amount",
  // value_of_inventory_available_in_store",
  // fund_held",
  // total_value_held_for_smart_items
  // value_of_required_inventory
  // value_to_be_accumulated_for_ideal_assortment
  // last_margin_settled_amount
  // excess_funds_settlement_amount
  // total_settlement_amount
  // num_of_sku_of_required_inventory
  // last_margin_settled_date
  // excess_funds_settlement_date
  // total_settlement_made_on
  // ✅ validation function
  const validateRow = (row) => {
    const errors = [];

    requiredFields.forEach((field) => {
      if (
        !(field in row) ||
        // row[field] === "" ||
        row[field] === null ||
        row[field] === undefined
        // ||
        // Number(row[field]) === 0
      ) {
        errors.push(`Missing or invalid value for field: ${field}`);
      }
      // else if (row[field] !== "" && isNaN(Number(row[field]))) {
      //   errors.push(`${field} must be a number`);
      // }
    });

    return errors;
  };

  // ✅ CSV load handler
  const handleFileLoad = (data, fileInfo) => {
    const headers = data[0];

    const processedData = data
      .slice(1)
      .filter((row) => row.some((cell) => cell && cell.trim() !== ""))
      .map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          obj[header.trim()] = row[index] ? row[index].trim() : "";
        });
        return obj;
      });

    setData(processedData);
  };

  // ✅ Save or Cancel click
  const handleClick = async (action) => {
    if (action === "save") {
      setLoading(true);
      const results = { success: [], errors: [] };

      try {
        for (let index = 0; index < data.length; index++) {
          const row = data[index];
          const rowNumber = index + 2; // headers = row 1

          const validationErrors = validateRow(row);
          if (validationErrors.length > 0) {
            results.errors.push({
              row: rowNumber,
              message: validationErrors.join(", "),
            });
            continue;
          }
        }
        try {
          // ✅ send row to API
          await axios.post(
            "https://backend-197598313260.asia-south1.run.app/v1/import/seller_margin",
            {
              sellerMargins: data,
            }
          );
          results.success.push({
            message: "Data uploaded successfully",
          });
        } catch (err) {
          results.errors.push({
            message: err.message || "API error",
          });
        }
      } finally {
        setLoading(false);
        setResults(results);
      }
    } else if (action === "cancel") {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      setCsvKey(Date.now());
      setData([]);
      setResults({ success: [], errors: [] });
    }
  };

  // ✅ CSV template download
  const handleDownloadTemplate = () => {
    const csvContent = requiredFields.join(",");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "seller_margin_template.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Page
      title="Seller Dashboard Upload"
      showSaveButton={!loading}
      showCancelButton={!loading}
      onClick={handleClick}
      processing={loading}
    >
      {loading && <Loader show={loading} />}
      <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
        <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
          <button
            onClick={handleDownloadTemplate}
            disabled={loading}
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Download Template (CSV)
          </button>
          <div style={{ flexGrow: 1 }}>
            <CSVReader
              key={csvKey}
              inputRef={fileInputRef}
              cssClass="csv-reader-input"
              onFileLoaded={handleFileLoad}
              inputId="csv-upload"
              inputStyle={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                width: "100%",
              }}
              disabled={loading}
            />
          </div>
        </div>

        {/* ✅ Show validation results */}
        {data.length > 0 && results.errors.length === 0 && !loading && (
          <div style={{ color: "green", marginBottom: "20px" }}>
            All rows are valid and ready to upload ({data.length} rows)
          </div>
        )}

        {results.errors.length > 0 && (
          <div style={{ color: "red", marginBottom: "20px" }}>
            <h3>Validation Errors ({results.errors.length})</h3>
            <ul>
              {results.errors.map((error, index) => (
                <li key={index}>
                  Row {error.row}: {error.message}
                </li>
              ))}
            </ul>
          </div>
        )}

        {loading && <Loader show={loading} />}
      </div>
    </Page>
  );
}

export default PincodeSmartMerchantDashboard;
